import { useQuery } from '@tanstack/react-query';

import { createClient } from 'contentful';

import { getConfig } from '../../../utils/getConfig.ts';
import { SidebarUpdateSkeleton } from '../components/UpdatesList/types.ts';

const client = createClient({
  space: getConfig('CONTENTFUL_SPACE_ID'),
  accessToken: getConfig('CONTENTFUL_CONTENT_DELIVERY_ACCESS_TOKEN'),
});

const getEntries = async () => {
  const entryItems = await client.getEntries<SidebarUpdateSkeleton>({
    content_type: 'sidebarUpdate',
    order: ['-fields.isPinned'],
  });

  return entryItems.items;
};

export const useSidebarUpdates = () => {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['sidebarUpdates'],
    queryFn: getEntries,
  });

  return { updates: data, isLoading, isError };
};
